import gsap from 'gsap';
import { ease1 } from '../../easings';
import splittedText from '../../splitted-text';
import handleContentVideos from '../../../inits/pages/news-detail/handle-content-videos';

const ANIMATION_SELECTORS = {
    IMAGE: '.js-nd-header-parallax-wrapper',
    BOTTOM: '.js-nd-header-bottom',
    TITLE: '.js-nd-header-title',
    CONTENT: '.js-nd-content-container',
    BREADCRUMBS: 'a-breadcrumbs',
    BREADCRUMB: '.a-breadcrumbs__item',

    CARDS: {
        CARDS_CONTAINER: '.a-nd-cards-container',
        ITEM: '.a-nd-card',
        CONTROLS: '.a-nd-cards-controls',
    },
};

const init = () => {
    gsap.set(ANIMATION_SELECTORS.CARDS.CARDS_CONTAINER, { opacity: 0 });

    const titleElement = document.querySelector<HTMLElement>(ANIMATION_SELECTORS.TITLE);

    const firstViewportTimeline = gsap.timeline({ defaults: { duration: 1, ease: ease1 } });

    const splittedTitleTween = titleElement ? splittedText(titleElement) : null;

    firstViewportTimeline
        .to(ANIMATION_SELECTORS.IMAGE, {
            opacity: 1,
            onStart: () => {
                setTimeout(() => {
                    splittedTitleTween?.play();
                }, 200);
            },
        })
        .fromTo(ANIMATION_SELECTORS.BOTTOM, { y: 7 }, { y: 0, opacity: 1, duration: 1.4 })
        .fromTo(
            ANIMATION_SELECTORS.CONTENT,
            { opacity: 0 },
            {
                opacity: 1,
                onStart: () => {
                    handleContentVideos.init();
                },
            },
            '-=0.7',
        )
        .fromTo(
            ANIMATION_SELECTORS.BREADCRUMB,
            { opacity: 0 },
            { duration: 1.4, opacity: 1, delay: -0.8, stagger: 0.17 },
        )
        .to(ANIMATION_SELECTORS.CARDS.CARDS_CONTAINER, { duration: 1.5, opacity: 1, delay: -1.3 });

    gsap.to(ANIMATION_SELECTORS.IMAGE, {
        y: window.innerHeight * 0.3,
        ease: 'none',
        scrollTrigger: {
            trigger: ANIMATION_SELECTORS.IMAGE,
            scrub: true,
            start: 'top top',
            end: 'bottom top',
        },
    });

    const ndCardsimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ANIMATION_SELECTORS.CARDS.CARDS_CONTAINER,
            start: 'top bottom-=30%',
        },
        defaults: { duration: 1, ease: ease1 },
    });

    ndCardsimeline
        .to(ANIMATION_SELECTORS.CARDS.ITEM, { opacity: 1, x: '0vw', delay: -1 })
        .fromTo(ANIMATION_SELECTORS.CARDS.CONTROLS, { opacity: 0 }, { duration: 1.4, opacity: 1, delay: -1 });
};

const _module = { init };

export default _module;
